const sizeConfigs = {
  sidebar: {
    width: '234px',
  },
};

export default sizeConfigs;
